// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientsUI_view__fosTu {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ClientsUI_loader__ec55a {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ClientsUI_infoWrap__lJ7j9 {
  background-color: white;
  box-shadow: 0 2px 15px rgba(100, 100, 100, 0.15);
  border-radius: 6px;
  margin-bottom: 40px;
  padding: 20px 0;
}

.ClientsUI_infoCol__qzX1R {
  padding: 0 20px;
}

.ClientsUI_infoCol__qzX1R span {
  display: block;
  margin-bottom: 15px;
}

.ClientsUI_infoCol__qzX1R span:last-child {
  margin-bottom: 0;
}

.ClientsUI_actions__mZQbB {
  display: flex;
  align-items: baseline;
}

.ClientsUI_switchWrap__waxVe {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}

.ClientsUI_eye__2xvB5 {
  background-color: transparent;
  color: var(--orange);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
}

.ClientsUI_eye__2xvB5 svg {
  width: 22px;
  height: 22px;
}

.ClientsUI_titleTable__Mi0KC{
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.ClientsUI_divider__Cfv8L{
  height: 20px;
  border-width: 1px;
}

.ClientsUI_actions__mZQbB svg{
  cursor: pointer;
}

.ClientsUI_header__L5zU3{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
}

.ClientsUI_title__BRvWW{
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.ClientsUI_label__CXCS5{
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.ClientsUI_input__oeyeV,
.ClientsUI_input__oeyeV .ant-select-selector{
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important ;
  border-radius: 4px !important;
}

.ClientsUI_itemColumn__45It1 {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.ClientsUI_itemSubmit__VGaXg{
  margin-bottom: 0px;
  text-align: right;
  margin-top: 20px;
}

.ClientsUI_submit__BTI0b {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/pages/client-detail/styles/ClientsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.infoWrap {\n  background-color: white;\n  box-shadow: 0 2px 15px rgba(100, 100, 100, 0.15);\n  border-radius: 6px;\n  margin-bottom: 40px;\n  padding: 20px 0;\n}\n\n.infoCol {\n  padding: 0 20px;\n}\n\n.infoCol span {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.infoCol span:last-child {\n  margin-bottom: 0;\n}\n\n.actions {\n  display: flex;\n  align-items: baseline;\n}\n\n.switchWrap {\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n}\n\n.eye {\n  background-color: transparent;\n  color: var(--orange);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n.eye svg {\n  width: 22px;\n  height: 22px;\n}\n\n.titleTable{\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.divider{\n  height: 20px;\n  border-width: 1px;\n}\n\n.actions svg{\n  cursor: pointer;\n}\n\n.header{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #cfcfcf;\n  padding-bottom: 15px;\n}\n\n.title{\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.label{\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.input,\n.input :global(.ant-select-selector){\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important ;\n  border-radius: 4px !important;\n}\n\n\n.itemColumn {\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.itemSubmit{\n  margin-bottom: 0px;\n  text-align: right;\n  margin-top: 20px;\n}\n\n.submit {\n  width: 250px;\n  font-weight: 700;\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ClientsUI_view__fosTu`,
	"loader": `ClientsUI_loader__ec55a`,
	"infoWrap": `ClientsUI_infoWrap__lJ7j9`,
	"infoCol": `ClientsUI_infoCol__qzX1R`,
	"actions": `ClientsUI_actions__mZQbB`,
	"switchWrap": `ClientsUI_switchWrap__waxVe`,
	"eye": `ClientsUI_eye__2xvB5`,
	"titleTable": `ClientsUI_titleTable__Mi0KC`,
	"divider": `ClientsUI_divider__Cfv8L`,
	"header": `ClientsUI_header__L5zU3`,
	"title": `ClientsUI_title__BRvWW`,
	"label": `ClientsUI_label__CXCS5`,
	"input": `ClientsUI_input__oeyeV`,
	"itemColumn": `ClientsUI_itemColumn__45It1`,
	"itemSubmit": `ClientsUI_itemSubmit__VGaXg`,
	"submit": `ClientsUI_submit__BTI0b`
};
export default ___CSS_LOADER_EXPORT___;
